module.exports = __webpack_public_path__ + "assets/img/1741589512664_.pic_hd.b37821ad.jpg";